import { styled, Grid, Box, Theme, LinearProgress } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_CONTAINER_FIELDS_FLOATING,
  DARK_FIELDS_ON_CARD_HEADER_LINE,
  LIGHT_CONTAINER_FIELDS_FLOATING,
  LIGHT_HEADER_LINE,
  PRIMARY_BAR_PROGRESS,
} = COLORS;

export const MainCont = styled(Grid)(({ theme }) => ({
  backgroundColor: 'transparent',
  [theme.breakpoints.down(1260)]: {
    flexDirection: 'column',
  },
}));

export const BorderedCont = styled(Box)<Theme, { padding?: number }>(({ theme, padding }) => ({
  background: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER_FIELDS_FLOATING,
  border: 'none',
  borderRadius: 8,
  marginBottom: 20,
  padding: padding,
}));

export const Head = styled(Box)(({ theme }) => ({
  borderBottom:
    theme.palette.type === 'dark' ? `1px solid ${DARK_FIELDS_ON_CARD_HEADER_LINE}` : `1px solid ${LIGHT_HEADER_LINE}`,
  paddingBottom: 10,
  marginBottom: 20,
  display: 'flex',
}));

export const Info = styled(Box)(({ theme }) => ({
  marginBottom: 20,
}));

export const InfoItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: 10,
}));

export const Foot = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginTop: 10,
}));

export const StorageBar = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  '& .MuiLinearProgress-bar ': {
    backgroundColor: PRIMARY_BAR_PROGRESS,
  },
}));

export const Content = styled(Box)<Theme, { maxHeight?: number | string }>(({ theme, maxHeight }) => ({
  padding: 10,
  display: 'flex',
  overflow: 'auto',
  flexWrap: 'wrap',
  maxHeight: maxHeight || 400,
}));

export const VideoContentContainer = styled('div')(({ theme, column }: { theme: Theme; column?: number }) => ({
  padding: 30,
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: 30,
  width: '100%',
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: `repeat(${column !== undefined ? column : 5}, 1fr)`,
  },
}));

export const NoMediaCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  paddingBottom: 100,
  fontSize: 18,
}));
